import React, {useEffect, useState} from "react";
import {AdditionalSellUnit, MenuItem} from "../../@types/stores/menu";
import { observer } from "mobx-react";
import "./style.scss";
import {getAllergenById, getHost} from "../../helpers/ApiHelper";
import defaultImg from "../../assets/images/default.webp";
import { useTranslation } from "react-i18next";
import orderStore from "../../stores/order";
import {useLocation, useNavigate, useParams} from "react-router";
import menuStore from "../../stores/menu";
import { moveToTop } from "../../helpers/DomHelper";
import useLayoutStyles from "../../hooks/styles";
import SellUnitsGroup from "../MenuItem/SellUnitsGroup";
import {ArticleViewType} from "../../@types/enums/ArticleViewType";
import {OrderLine} from "../../@types/stores/order";

export interface AdditionalSellUnitsProps {
    item: MenuItem;
    sellUnits: AdditionalSellUnit[];
    skipRecommendations: boolean;
    isHalfAndHalf?: boolean;
}

const AdditionalSellUnits = ({ item, sellUnits, skipRecommendations, isHalfAndHalf}: AdditionalSellUnitsProps) => {
    const params = useParams();
    const [t] = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const styles = useLayoutStyles();

    const [additionalSellUnit, setAdditionalSellUnit] = useState<AdditionalSellUnit | undefined>(sellUnits?.find(x => x.isDefault));

    useEffect(() => {
        if (orderStore.currentOrderLine?.sellUnitId && additionalSellUnit?.sellUnitId !== orderStore.currentOrderLine.sellUnitId)
            setAdditionalSellUnit(sellUnits.find(x => x.sellUnitId === orderStore.currentOrderLine?.sellUnitId));
    }, [location]);

    useEffect(() => {
        if (additionalSellUnit && orderStore.currentOrderLine) {
            orderStore.currentOrderLine.sellUnitId = additionalSellUnit.sellUnitId;
            orderStore.currentOrderLine.sellFactor = additionalSellUnit.sellFactor;

            orderStore.currentOrderLine.price = additionalSellUnit.price;
            orderStore.currentOrderLine.total = additionalSellUnit.price * orderStore.currentOrderLine.count;
        }
    }, [additionalSellUnit]);

    const changeSellUnit = (sellUnit: AdditionalSellUnit) => {
        setAdditionalSellUnit(sellUnit);

        if (orderStore.currentOrderLine) {
            orderStore.currentOrderLine.sellUnitId = sellUnit.sellUnitId;
            orderStore.currentOrderLine.sellFactor = sellUnit.sellFactor;

            orderStore.currentOrderLine.price = sellUnit.price;
            orderStore.currentOrderLine.total = sellUnit.price * orderStore.currentOrderLine.count;
        }
    }

    const goNext = () => {
        moveToTop();

        // Menu article
        if (!skipRecommendations) {
            if (localStorage.getItem("articleViewType") === ArticleViewType.GROUP_PAGE) {
                if (item.modifierGroups?.length) {
                    navigate(`/menu${isHalfAndHalf ? "/halfAndHalf" : ""}/${menuStore.navigation.category}/${menuStore.navigation.subCategory}/${item.number}/modifiers`);
                    return;
                }
                if (item.addonGroups?.length) {
                    navigate(`/menu${isHalfAndHalf ? "/halfAndHalf" : ""}/${menuStore.navigation.category}/${menuStore.navigation.subCategory}/${item.number}/addons`);
                    return;
                }
                if (item.addonGroups?.length) {
                    navigate(`/menu${isHalfAndHalf ? "/halfAndHalf" : ""}/${menuStore.navigation.category}/${menuStore.navigation.subCategory}/${item.number}/ingredients`);
                    return;
                }
            }
            else if (localStorage.getItem("articleViewType") === ArticleViewType.INDIVIDUAL_PAGE) {
                if (item.modifierGroups?.length) {
                    moveToTop();
                    navigate(`/menu${isHalfAndHalf ? "/halfAndHalf" : ""}/${menuStore.navigation.category}/${menuStore.navigation.subCategory}/${item.number}/modifiers/${item.modifierGroups.at(0)?.id}`);
                    return;
                } else if (item.addonGroups?.length) {
                    moveToTop();
                    navigate(`/menu${isHalfAndHalf ? "/halfAndHalf" : ""}/${menuStore.navigation.category}/${menuStore.navigation.subCategory}/${item.number}/addons/${item.addonGroups.at(0)?.id}`);
                    return;
                } else if (item.ingredientGroups?.length) {
                    moveToTop();
                    navigate(`/menu${isHalfAndHalf ? "/halfAndHalf" : ""}/${menuStore.navigation.category}/${menuStore.navigation.subCategory}/${item.number}/ingredients`);
                    return;
                }
            }
        }
        // Recommendation article
        else {
            if (typeof params.groupId !== "undefined") {
                const groupId = params.groupId && !isNaN(+params.groupId) ? +params.groupId : 0;
                if (groupId) {
                    if (item.modifierGroups?.length) {
                        navigate(`/recommendations/${groupId}/${item.number}/modifiers`);
                        return;
                    }
                    if (item.addonGroups?.length) {
                        navigate(`/recommendations/${groupId}/${item.number}/addons`);
                        return;
                    }
                    if (item.ingredientGroups?.length) {
                        navigate(`/recommendations/${groupId}/${item.number}/ingredients`);
                        return;
                    }
                }
            }
        }

        if (orderStore.currentOrderLine) {
            if (isHalfAndHalf) {
                if (menuStore.selectedHalfAndHalfStep >= 0) {
                    orderStore.currentOrderLine.count = 0.5;

                    const newArr: OrderLine[] = [...menuStore.selectedHalfAndHalfItems] as OrderLine[];
                    newArr[menuStore.selectedHalfAndHalfStep] = orderStore.currentOrderLine;
                    menuStore.selectedHalfAndHalfItems = newArr;

                    orderStore.currentOrderLine = null;
                }

                navigate(`/menu/halfAndHalf/${menuStore.halfAndHalfNavigation.category}/${menuStore.halfAndHalfNavigation.subCategory}`);
                return;
            }

            orderStore.addToOrder(orderStore.currentOrderLine);
        }

        if (menuStore.returnToScanArticle) {
            navigate("/scanArticle");

            return;
        }

        // from recommendations
        if (skipRecommendations) {
            if (menuStore.navigation.item) {
                const item = menuStore.getItemById(menuStore.navigation.item);

                if (item?.recommendedGroups?.length) {
                    const nextGroupIdIndex = item.recommendedGroups.findIndex(x => x === menuStore.navigation.recommendationGroupId) + 1;
                    if (nextGroupIdIndex && nextGroupIdIndex < item.recommendedGroups.length) {
                        const nextGroupId = item.recommendedGroups.at(nextGroupIdIndex);
                        navigate(`/recommendations/${nextGroupId}`);
                        return;
                    }
                }
            }

            navigate("/menu");
            return;
        }

        navigate("/recommendations");
    }

    if (!item)
        return null;

    return <div className="AdditionalSellUnits">
        <h2>{item.name}</h2>
        <div className="img" style={{ backgroundImage: `url(${item.previewEdit ? `${getHost()}${item.previewEdit}` : (styles?.article.defaultEditImage ? `${getHost()}${styles.article.defaultEditImage}` : defaultImg)}` }} />
        <div className="description">{item.description || ""}</div>
        <div className="allergens">
            {item.allergens?.map(allergenId => getAllergenById(allergenId)?.name || null).filter(name => !!name).map(name => <div key={name} className="allergen">{name}</div>)}
        </div>
        <SellUnitsGroup sellUnits={sellUnits} onChange={changeSellUnit} selected={additionalSellUnit || sellUnits.find(x => x.isDefault) || sellUnits[0]} />
        <div className={`button dark`} onClick={goNext}>{t(`next`)}</div>
    </div>
}

export default observer(AdditionalSellUnits);
